import mlVehicleCoverages from '../config/ml-available-vehicle-coverages.json'

const defaultConfig = {
    coverages: mlVehicleCoverages.coverages
};
const config = Object.assign({}, defaultConfig);

export default {
    getCoverage: (code) => {
        return config.coverages.find((item) => item.code === code);
    }
};